class AbstractCrudControllerConfiguration

  getService: () ->
    if @service?
      @service
    else if @model?
      "#{@model}Service"
    else
      throw 'O parâmetro service ou model não está configurado.'

  getModalController: () ->
    if @modalController?
      @modalController
    else if @model?
      "#{@model}ModalController"
    else
      throw 'O parâmetro modalController ou model não está configurado.'

  getModule: () ->
    @module || throw 'O parâmetro module não está configurado.'

  getFolder: () ->
    @folder || throw 'O parâmetro module não está configurado.'

  getItemName: (item) ->
    if @itemName?
      @itemName(item)
    else
      'o item'

class AbstractCrudController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService']

  constructor: (@injector, @scope, @pathService, canLoadData = true) ->
    super(@injector)

    @filtro = {}
    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @configs = new AbstractCrudControllerConfiguration()
    @configure(@configs)

    @loadingTracker = @promiseTracker()
    @setModal('modal', 'modal', @configs.getModalController())

    @initialize()
    
    @loadData() if canLoadData    

  configure: -> throw "É preciso implementar o método configure."

  initialize: -> null

  loadData: (page = 1) ->
    filtro = angular.copy @getFiltro()

    filtro.page = page

    @loadingTracker.addPromise @service().getList(filtro, (result) =>
      if result.success
        @listOfData = result.data.items or result.data

        @pagination =
          page: page
          totalPages: result.data.totalPages or result.data.total_pages
          perPage: result.data.page_size || 1
      else
        @Alert.error('Ocorreu um erro ao carregar a listagem.', 'Erro!', false)
    )

  add: ->
    @modal(@modalResolve(), @addCallback())

  edit: (item) ->
    @modal(@modalResolve(item), @editCallback())

  remove: (item)->
    Confirm.warning('Atenção', "Deseja realmente remover #{@configs.getItemName(item)}?", {
      Sim: =>
        @service().delete(item.id, (result)=>
          if(result.success)
            Alert.success("A remoção d#{@configs.getItemName(item)} foi realizada com sucesso!", 'Sucesso')
            @loadData()
          else
            Alert.error("Ocorreu um erro ao remover #{@configs.getItemName(item)}.")
        )
      Não: ''
    })

  modalResolve: (item = {}) ->
    { item: -> angular.copy(item) }

  addCallback: ->
    (result) =>
      if result.ok
        @loadData()
      else
        @Alert.warning(result.message, 'Ocorreu um erro', false)

  editCallback: ->
    (result) =>
      if result.ok
        @loadData()
      else
        @Alert.warning(result.message, 'Ocorreu um erro', false)

  setModal: (modal, file, controller, options = {}) ->
    @[modal] = @openPopup("#{@pathService.getViewUrl()}#{@configs.getModule()}/view/#{@configs.getFolder()}/#{file}.html", "#{controller} as ctrl", null, true, options)

  inject: (provider) ->
    @injector.invoke([provider,
      (loadedProvider) =>
        @[provider] = loadedProvider
    ])

  service: () ->
    if @[@configs.getService()] is undefined
      @inject(@configs.getService())

      while @[@configs.getService()] is undefined
        'wait'

    @[@configs.getService()]

  getFiltro: ->
    @filtro

window.AbstractCrudControllerConfiguration = AbstractCrudControllerConfiguration
window.AbstractCrudController = AbstractCrudController
